import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3cb63824&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3cb63824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb63824",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cb63824')) {
      api.createRecord('3cb63824', component.options)
    } else {
      api.reload('3cb63824', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3cb63824&scoped=true&", function () {
      api.rerender('3cb63824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screenFull/index.vue"
export default component.exports